import React from 'react';
import { cn } from '../../utils';

const AsyncContent = ({
    loading,
    skeleton,
    children,
    className,
    durationClass = 'duration-300',
}) => (
    <div className={cn('grid', className)}>
        <div
            aria-hidden={!loading}
            className={cn(
                'col-start-1 row-start-1 transition-opacity ease-in-out',
                durationClass,
                loading ? 'opacity-100' : 'opacity-0 pointer-events-none',
            )}
        >
            {skeleton}
        </div>
        <div
            aria-hidden={loading}
            className={cn(
                'col-start-1 row-start-1 transition-opacity ease-in-out',
                durationClass,
                loading ? 'opacity-0 pointer-events-none' : 'opacity-100',
            )}
        >
            {children}
        </div>
    </div>
);

export default AsyncContent;
